import { useIntl } from 'react-intl'
import React, { useContext } from 'react'
import GeoContext from 'contexts/geoContext'
import Tooltip from 'LuxKit/Tooltip'
import CaptionTextBlock from 'LuxKit/TextBlocks/CaptionTextBlock'
import LineMapMarkerIcon from 'LuxKit/Icons/line/LineMapMarkerIcon'
import { getSearchDistanceLabel } from './searchDistanceLabel'

interface Props {
  searchTargetLabel: string
  distance: number
}

function SearchTargetDistance(props: Props) {
  const intl = useIntl()
  const { currentRegionCode } = useContext(GeoContext)
  const label = getSearchDistanceLabel(intl, props.searchTargetLabel, props.distance, currentRegionCode)

  return <Tooltip
    description={intl.formatMessage({
      id: 'C5fCtylAHF-mqnZf5ehv',
      defaultMessage: 'This distance is calculated as a straight line on a map. Actual travel distance may vary.',
      description: 'Tooltip explaining how the distance to search target is calculated',
    })}
  >
    <CaptionTextBlock
      variant="medium"
      colour="neutral-two"
      startIcon={<LineMapMarkerIcon />}
    >
      {label}
    </CaptionTextBlock>
  </Tooltip>
}

export default SearchTargetDistance
